import styled from 'styled-components';
import { Table } from 'ui/table';
import { colors, spacing } from 'ui/theme';
import { FullWidth } from 'ui/utility/fullWidth';

export const TableWrapper = styled(FullWidth)<{ withHorizontalScroll: boolean }>`
  margin-top: ${spacing.double};
  border-bottom: ${`${spacing.single} solid ${colors.grey15}`};
  overflow-x: ${({ withHorizontalScroll }) => (withHorizontalScroll ? 'scroll' : 'visible')};
`;

export const StyledTable = styled(Table)<{ withHorizontalScroll: boolean }>`
  border: ${`${spacing.single} solid ${colors.grey15}`};
  ${({ withHorizontalScroll }) =>
    withHorizontalScroll ? 'table-layout: auto' : 'table-layout: fixed;'}
`;

export const EmptyStateWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: ${spacing.half};
  justify-content: center;
  padding: ${spacing.x4};
  position: relative;
  width: 100vw;
`;
